import React from 'react'
import { Route, Routes } from "react-router-dom";
import Home from '../components/home';
import LinkedInCallback from '../components/callback';
import FacebookCallback from '../components/FacebookCallback';
import Calendarpage from '../components/calendar';
import AIComponent from '../components/ai';
import UserForm from '../components/userform';
import PostToLinkedIn from '../components/posttoLinkedin';
import { SidebarProvider } from '../components/helpers/sidebarcontext';
import Register from '../components/account/register';
import Login from '../components/account/login';
import IntegrateSocialMedia from '../components/integration/integratesocialmedia';
import { useLocation } from 'react-router-dom';
import Post from '../components/post';
import ScheduleList from '../components/schedulelist';
import EditSchedulePost from '../components/editschedulepost';
import ViewAllPendingPosts from '../components/viewallpendingposts';
import UpdatePendingPost from '../components/updatependingpost';
import ViewAllApprovedPosts from '../components/viewallapprovedposts';
import ViewPostScheduleDet from '../components/viewpostscheduledet';
import ViewApprovedAiGeneratedSchedulePost from '../components/viewapprovedAigeneratedschedulepost';
import UpdatePendingPostDropdown from '../components/updatependingpostdropdown';
import AdminHome from '../components/adminhome';
import ListOfUsers from '../components/listofusers';
import ErrorLogs from '../components/errorlogs';
import ViewAllTodaysPosts from '../components/ViewAllTodaysPosts.jsx';
import ViewAllPostedPosts from '../components/viewallpostedposts';
import ViewPostComments from '../components/viewpostcomments';
import ViewPostPerformance from '../components/viewpostperformance';
import TopPerformingPosts from '../components/TopPerformingPosts.jsx';
import ViewEachPostPerformance from '../components/vieweachpostperformance';
import AddUser from '../components/adduser';
import UsersList from '../components/userslistunderclient';
import ResetPassword from '../components/resetpassword';
import Pagehome from '../components/pagehome';
import Approvepost from '../components/approvepost';
import PendingPost from '../components/pendingpost.js';
import SuperAdminLogin from '../components/account/SuperAdminLogin.js';
import Updatelatesttrendingnews from '../components/updatelatesttrendingnews.js';
import Stripe from '../components/stripe.js';
import PricingSection from '../components/subscription.js';
import EditPost from '../components/editpost.js';
import PostToLinkedInEmail from '../components/posttolinkedInemail.js';
import LandingPage from '../landing/landingpage.js';
import SubscriptionStatus from '../components/subscriptionstatus.js';
import ViewLatestTrendingPost from '../components/viewlatesttrendingpost.js';
import PersonalHome from '../components/personalhome.js';
import BusinessHome from '../components/businesshome.js';
import LinkedInThankYou from '../components/thanksmessage.js';
import SubscribedUsersList from '../components/subscribeduserslist.js';
import ViewAllPosts from '../components/viewallposts.jsx';
import ViewAiGeneratedSchedulePost from '../components/viewAigeneratedschedulepost.js';
import UserInterestsList from '../components/userinterestslist.js';
import SavedPromptsList from '../components/savedpromptslist.js';
import ViewPostedAiGeneratedSchedulePost from '../components/viewpostedAigeneratedschedulepost.js';
import Verifyemail from '../components/account/verifyemail.js';
import ViewPendingAiGeneratedSchedulePost from "../components/viewpendingAigeneratedschedulepost.js"
import ForgotPassword from '../components/account/forgotpassword.js';
import BeforeLoginChangePassword from '../components/account/beforeloginchangepassword.js';
import BeforeLoginResetPassword from '../components/account/beforeloginresetpassword.js';
import ChallengeApprovePost from '../components/ChallengeApprovePost.js';
import ChallengeEditPost from '../components/ChallengeEditPost.js';
import Resources from '../components/resources.js';
import PaymentManager from '../components/PaymentManager.jsx';
import SelectLinkedInPage from '../components/SelectLinkedInPage.js';
import SelectFacebookPage from '../components/SelectFacebookPage.js';
import FeatureLimitsDashboard from '../components/FeatureLimits/FeatureLimitsDashboard.jsx';
import ReferralSystem from '../components/FeatureLimits/ReferralSystem.jsx';
import KnackMomentsWithLimits from '../components/FeatureLimits/KnackMomentsWithLimits.jsx';
import KnackFeedsWithLimits from '../components/FeatureLimits/KnackFeedsWithLimits.jsx';
import ReportIssue from '../components/ReportIssue.jsx';
import PollsWithLimits from '../components/FeatureLimits/PollsWithLimits.jsx';
import ChallengesWithLimits from '../components/FeatureLimits/ChallengesWithLimits.jsx';
import ChallengesWithSmartLimits from '../components/FeatureLimits/ChallengesWithSmartLimits.jsx';
import PostTextWithLimits from '../components/FeatureLimits/PostTextWithLimits.jsx';
import ScheduleFormWithLimits from '../components/FeatureLimits/ScheduleFormWithLimits.jsx';
import OnboardingForm from '../components/OnboardingForm.jsx';
import OnboardingLinkedInCallback from '../components/OnboardingLinkedInCallback.jsx';
import OnboardingPaymentWrapper from '../components/OnboardingPaymentWrapper.jsx';
import OnboardingLinkGenerator from '../components/OnboardingLinkGenerator.jsx';
import Receipt from '../components/Receipt.jsx';
import CreatePostPage from '../components/CreatePostPage.jsx';
import RoleHomeRedirect from '../components/RoleHomeRedirect.jsx';
import PlatformSettings from '../components/PlatformSettings.jsx';
import PrivacyPolicy from '../landing/privacypolicy.js';

const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};
const Knackroutes = () => {
  const query = useQuery();
  const tokenID = query.get('tokenID');
  const AccountType = localStorage.getItem('AccountType');

  return (
    <div>


      <SidebarProvider>
        <Routes>
          {/* {tokenID==null&& <Route path="/" element={<Login/>} />} */}
          {tokenID == null && <Route path="/" element={<LandingPage />} />}
          {AccountType === "User" ? <Route path="/" element={<Home />} /> : <Route path="/" element={<Pagehome />} />}
          <Route path="/Register" element={<Register />} />
          <Route path="/Login" element={<Login />} />
          <Route path="/verifyemail" element={<Verifyemail />} />
          <Route path="/forgotpassword" element={<ForgotPassword />} />
          <Route path="/resetpassword" element={<BeforeLoginResetPassword />} />
          <Route path="/changepassword" element={<BeforeLoginChangePassword />} />
          <Route path="/Superadminlogin" element={<SuperAdminLogin />} />
          <Route path="/home" element={<Home />} />
          <Route path="/Adminhome" element={<AdminHome />} />
          <Route path='/Pagehome' element={<Pagehome />} />
          <Route path="/personalhome" element={<PersonalHome />} />
          <Route path="/businesshome" element={<BusinessHome />} />
          <Route path="/linkedin" element={<LinkedInCallback />} />
          <Route path="/auth/facebook/callback" element={<FacebookCallback />} />
          <Route path="/calendar" element={<Calendarpage />} />
          <Route path="/ai" element={<AIComponent />} />
          <Route path="/user-form" element={<UserForm />} />
          <Route path="/post-text" element={<PostTextWithLimits />} />
          <Route path="/post-to-linkedin" element={<PostToLinkedIn />} />
          <Route path="/schedule" element={<ScheduleFormWithLimits />} />
          <Route path="/integrations" element={<IntegrateSocialMedia />} />
          <Route path="/viewallpendingposts" element={<ViewAllPendingPosts />} />
          <Route path="/post" element={<Post />} />
          <Route path="/schedule-list" element={<ScheduleList />} />

          <Route path="/editschedulepost/:PostId" element={<EditSchedulePost />} />
          <Route path="/viewPendingAigeneratedschedulepost/:ContentId" element={<ViewPendingAiGeneratedSchedulePost />} />
          <Route path="/viewPostedAigeneratedschedulepost/:ContentId" element={<ViewPostedAiGeneratedSchedulePost />} />
          <Route path="/viewApprovedAigeneratedschedulepost/:ContentId" element={<ViewApprovedAiGeneratedSchedulePost />} />

          <Route path="/updatependingpost/:ContentId" element={<UpdatePendingPost />} />
          <Route path="/updatependingpostdropdown/:ContentId" element={<UpdatePendingPostDropdown />} />

          <Route path="/viewallapprovedposts" element={<ViewAllApprovedPosts />} />
          <Route path="/viewallpostedposts" element={<ViewAllPostedPosts />} />
          <Route path="/todays-posts" element={<ViewAllTodaysPosts />} />
          <Route path="/viewpostcomments/:LinkdinPostId" element={<ViewPostComments />} />

          <Route path="/viewpostsperformance" element={<ViewPostPerformance />} />
          <Route path="/topperformingposts" element={<TopPerformingPosts />} />
          <Route path="/vieweachpostperformance/:LinkdinPostId" element={<ViewEachPostPerformance />} />

          <Route path="/updatelatesttrendingnews/:ContentID" element={<Updatelatesttrendingnews />} />

          <Route path="/ViewPostscheduleDet/:PostId" element={<ViewPostScheduleDet />} />
          <Route path="/KnackMoments" element={<KnackMomentsWithLimits />} />
          <Route path="/KnackFeeds" element={<KnackFeedsWithLimits />} />
          <Route path="/report-issue" element={<ReportIssue />} />
          <Route path="/payment" element={<Stripe />} />
          <Route path="/subscription" element={<PricingSection />} />
          <Route path="/receipt" element={<Receipt />} />
          <Route path="/paymentManager" element={<PaymentManager />} />


          <Route path="/listofusers" element={<ListOfUsers />} />
          <Route path="/errorlogs" element={<ErrorLogs />} />
          <Route path="/adduser" element={<AddUser />} />
          <Route path="/userslist" element={<UsersList />} />
          <Route path="/resetpassword/:Guid" element={<ResetPassword />} />
          <Route path="/approve-post" element={<Approvepost />} />
          <Route path="/pending-post" element={<PendingPost />} />
          <Route path="/edit-post" element={<EditPost />} />
          <Route path="/posttolinkedin" element={<PostToLinkedInEmail />} />

          <Route path="/#LandingPage" element={<LandingPage />} />
          <Route path="/LandingPage" element={<LandingPage />} />
          <Route path="/" element={<LandingPage />} />
          <Route path="/SubscriptionStatus" element={<SubscriptionStatus />} />
          <Route path="/viewlatesttrendingpost/:ContentID" element={<ViewLatestTrendingPost />} />
          <Route path="/LinkedInThankYou" element={<LinkedInThankYou />} />
          <Route path="/subscribeduserslist" element={<SubscribedUsersList />} />
          <Route path="/userinterestslist" element={<UserInterestsList />} />
          <Route path="/savedpromptslist" element={<SavedPromptsList />} />
          <Route path="/allposts" element={<ViewAllPosts />} />
          <Route path="/viewAigeneratedschedulepost/:ContentId" element={<ViewAiGeneratedSchedulePost />} />
          {/* KnackChallenges Route */}
          <Route path="/KnackChallenges" element={<ChallengesWithSmartLimits />} />
          <Route path="/approve-challengepost" element={<ChallengeApprovePost />} />
          <Route path="/update-challengepost" element={<ChallengeEditPost />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/createpoll" element={<PollsWithLimits />} />
          <Route path="/selectLinkedInPage" element={<SelectLinkedInPage/>} />
          <Route path="/selectFacebookPage" element={<SelectFacebookPage/>} />
          <Route path="/feature-limits" element={<FeatureLimitsDashboard />} />
          <Route path="/referrals" element={<ReferralSystem />} />
          <Route path="/platformsettings" element={<PlatformSettings />} />
          <Route path="/onboarding" element={<OnboardingForm />} />
          <Route path="/onboarding-linkedin-callback" element={<OnboardingLinkedInCallback />} />
          <Route path="/onboarding-payment" element={<OnboardingPaymentWrapper />} />
          <Route path="/generate-onboarding-link" element={<OnboardingLinkGenerator />} />
          <Route path="/create-post" element={<CreatePostPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          {/* Redirect any links pointing to "/Post" to the correct role-based home */}
          <Route path="/Post" element={<RoleHomeRedirect />} />
        </Routes>
      </SidebarProvider>
    </div>
  )
}

export default Knackroutes